import { render } from "./childrenadd.vue?vue&type=template&id=1ed4d082&scoped=true"
import script from "./childrenadd.vue?vue&type=script&lang=js"
export * from "./childrenadd.vue?vue&type=script&lang=js"

import "./childrenadd.vue?vue&type=style&index=0&id=1ed4d082&lang=scss&scoped=true"
import "./childrenadd.vue?vue&type=style&index=1&id=1ed4d082&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed4d082"]])

export default __exports__